import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"

export const rateCards = api(async function rateCards({ skip, take, search, sort, descending, status }) {
    return query(
        gql`
            query GetRateCards(
                $skip: Int
                $take: Int
                $search: String
                $sort: RateCardSort
                $descending: Boolean
                $status: String
            ) {
                rateCards(
                    skip: $skip
                    take: $take
                    search: $search
                    sort: $sort
                    descending: $descending
                    status: $status
                ) {
                    totalCount
                    items {
                        id
                        name
                        description
                        skillMapId
                        skillMapName
                        skillMapIsArchived
                        currency
                        defaultRate
                        lines {
                            tradeId
                            tradeName
                            hourlyRate
                            minimumBillingPeriod
                            notes
                            mode
                            fixedAnnualAmount
                            skillOverrides {
                                skillId
                                hourlyRate
                            }
                        }
                        modifiers {
                            id
                            name
                            value
                            type
                            scope {
                                kind
                                value
                            }
                            applyTo
                        }
                        linkedScenarios {
                            id
                            name
                        }
                        isArchived
                        needsReview
                        created
                        modified
                    }
                }
            }
        `,
        { skip, take, search, sort, descending, status },
        { returns: "rateCards" }
    )
})
